import React from 'react';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';

import { Badge, BadgeProps } from 'components/v2';

import { BadgeViewerCounts_Viewer$key } from './__generated__/BadgeViewerCounts_Viewer.graphql';

export interface BadgeViewerCountsProps extends Omit<BadgeProps, 'classes' | 'badgeContent'> {
  fragmentRef: BadgeViewerCounts_Viewer$key;
}

const BadgeViewerCounts: React.FC<BadgeViewerCountsProps> = ({ fragmentRef, ...rest }) => {
  const viewer = useFragment<BadgeViewerCounts_Viewer$key>(
    graphql`
      fragment BadgeViewerCounts_Viewer on User {
        countUnread: unreadChatsCount
        countUnassigned: chatActivityUnassignedCount
      }
    `,
    fragmentRef,
  );

  return (
    <Badge
      badgeContent={viewer.countUnread || viewer.countUnassigned}
      badgeContentAsDot={!viewer.countUnread}
      {...rest}
    />
  );
};

export default BadgeViewerCounts;
